document.addEventListener('DOMContentLoaded', () => {
  const source = document.querySelector('.product-tab-panel[id^="ProductDescription-"]');
  const extract = (target, startPattern, stopPattern, emptyText) => {
    if (!source || !target) return;
    const nodes = [...source.children];
    const start = nodes.findIndex((node) => startPattern.test(node.textContent.trim()));
    if (start < 0) {
      target.innerHTML = `<p>${emptyText}</p>`;
      return;
    }
    const fragment = document.createDocumentFragment();
    for (let index = start + 1; index < nodes.length; index += 1) {
      const text = nodes[index].textContent.trim();
      if (stopPattern.test(text)) break;
      fragment.appendChild(nodes[index].cloneNode(true));
    }
    target.appendChild(fragment);
    if (!target.textContent.trim()) target.innerHTML = `<p>${emptyText}</p>`;
  };

  extract(
    document.querySelector('[data-product-fallback="includes"]'),
    /^(what(?:'|’)s included|includes|included items|package includes)/i,
    /^(vehicle fitment|fitment|installation|compatibility)/i,
    'The complete package contents are listed in the Description tab.'
  );
  extract(
    document.querySelector('[data-product-fallback="fitment"]'),
    /^(vehicle fitment|fitment|compatibility)/i,
    /^(installation|important|notes|warranty|what(?:'|’)s included|includes|included items|package includes)/i,
    document.querySelector('[data-product-fallback="fitment"]')?.dataset.emptyText || 'Contact us before ordering if you need help confirming compatibility.'
  );

  if (source && document.querySelector('[data-product-fitment-card]')) {
    const nodes = [...source.children];
    const start = nodes.findIndex((node) => /^(vehicle fitment|fitment|compatibility)/i.test(node.textContent.trim()));
    if (start >= 0) {
      let end = nodes.length;
      for (let index = start + 1; index < nodes.length; index += 1) {
        if (/^(installation|important|notes|warranty|what(?:'|’)s included|includes|included items|package includes)/i.test(nodes[index].textContent.trim())) {
          end = index;
          break;
        }
      }
      nodes.slice(start, end).forEach((node) => { node.hidden = true; });
    }
  }

  const productTabs = [...document.querySelectorAll('[data-product-tab]')];
  const activateTab = (tab) => {
    const target = tab.dataset.productTab;

    productTabs.forEach((item) => {
      const active = item === tab;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });

    document.querySelectorAll('.product-tab-panel').forEach((panel) => {
      const active = panel.id === target;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  };

  productTabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      activateTab(tab);
    });
    tab.addEventListener('keydown', (event) => {
      let nextIndex = null;
      if (event.key === 'ArrowRight') nextIndex = (index + 1) % productTabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + productTabs.length) % productTabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = productTabs.length - 1;
      if (nextIndex === null) return;
      event.preventDefault();
      activateTab(productTabs[nextIndex]);
      productTabs[nextIndex].focus();
    });
  });

  const deliveryWindow = document.querySelector('[data-delivery-window]');
  if (deliveryWindow) {
    const addBusinessDays = (start, days) => {
      const date = new Date(start);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        if (date.getDay() !== 0 && date.getDay() !== 6) added += 1;
      }
      return date;
    };
    const formatter = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const today = new Date();
    const minimumDays = Number(deliveryWindow.dataset.deliveryMinDays) || 5;
    const maximumDays = Number(deliveryWindow.dataset.deliveryMaxDays) || 10;
    deliveryWindow.textContent = `${formatter.format(addBusinessDays(today, minimumDays))}–${formatter.format(addBusinessDays(today, maximumDays))}`;
  }
});

